import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { textFieldProps } from "../../../shared/constants";
import { useState } from "react";
import { functions } from "../../../../firebase";
import { httpsCallable } from "firebase/functions";

export default function RunManualDateRangeBlueLabel({ open, close }) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [busy, setBusy] = useState(false);

  const handleManualReport = async () => {
    const manualRunBlueLabelReport = httpsCallable(
      functions,
      "manualRunBlueLabelReport"
    );
    setBusy(true);
    await manualRunBlueLabelReport({ startDate, endDate });
    setBusy(false);
  };

  const handleClose = () => {
    close();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Run Blue Label Report Manually</DialogTitle>
      <DialogContent>
        <TextField
          {...textFieldProps}
          label="Start Date (DD/MM/YYYY)"
          onChange={(e) => setStartDate(e.target.value)}
        />
        <TextField
          {...textFieldProps}
          label="End Date (DD/MM/YYYY)"
          onChange={(e) => setEndDate(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="error">
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleManualReport}
          disabled={busy}
        >
          Execute
        </Button>
      </DialogActions>
    </Dialog>
  );
}
